import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { UserLikesService } from "./userlikes.service";
import { ChangeDetectionStrategy } from "@angular/compiler/src/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { SnackBarMessageType, ContentType } from "../../shared/contentTypes";
import { LikeGroupViewModel } from "../../shared/models";
import { RouterHelperService } from "../../services/routerHelper.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { NavigationService } from "../../services/navigation.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";

@Component({
  selector: "user-likes",
  templateUrl: "./userLikes.component.html",
  styleUrls: ["./userLikes.component.scss"],
  providers: [UserLikesService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserLikesComponent implements OnInit, OnDestroy {
  private langSubscriber: Subscription;
  public userLikes: LikeGroupViewModel[] = [];
  public isSmallView: boolean = false;

  constructor(private _userLikesService: UserLikesService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _navigationService: NavigationService
    , private _location: Location
    , private _router: Router
    , private _snackBarService: SnackBarService
    , private _routerHelperService: RouterHelperService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private internationalisationService: InternationalisationService
    , _mainnavService: MainnavService) {
    this.isSmallView = _mainnavService.viewType === ViewType.Small;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("ForgetPasswordComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  // set path for the next path.
  private setRouteToNavigate(contentType: number) {
    const me = this;
    let path: string;
    switch (contentType) {
      case ContentType.News:
        path = "/news";
        break;
      case ContentType.Coupon:
        path = "/coupon";
        break;
      case ContentType.Event:
        path = "/event";
        break;
      case ContentType.Location:
        path = "/location";
        break;
      case ContentType.Menu:
        path = "/menu";
        break;
      case ContentType.Bonussystem:
        path = "/bonusaction";
        break;
      default:
        path = "/";
        break;
    }
    return path;
  }

  ngOnInit() {
    const me = this;
    me.langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me.getUserLikes();
    me.PushChanges();
  }

  private getUserLikes() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._userLikesService.GetAllLikes()
      .then((likes) => {
        // do not show menu and product like by filtering response until implement a like list page
        me.userLikes = likes.filter(r => me._navigationService.isContenttypeSupported(r.contentType) && r.contentType !== ContentType.Menu && r.contentType !== ContentType.sub_Product);
        me.PushChanges();
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch(e => {
        me._coreLogService.error("UserLikesComponent.getUserLikes", "GetAllLikes", e);
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(86);
      });
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me._location.back();
    }
  }

  public setSVGIcon(contentType: number) {
    const me = this;
    return `${me._navigationService.GetSvgNameForContentType(contentType)}.svg`;
  }

  public navigateTo(contentType: number): void {
    const me = this;
    me._router.navigateByUrl(me.setRouteToNavigate(contentType));
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }

}
